<template>
  <section-row
    title="Tiotaggarlösning"
    :is-loading="anstalldStore.itp2.isLoading"
  >
    <template
      v-slot:value
      v-if="
        anstalldStore.itp2.data?.tiotaggarlosning?.status ===
        TiotaggarlosningStatus.AktivOchInaktiv
      "
      ><span class="font-bold">Ja</span>
      <span class="date"
        >({{ anstalldStore.itp2.data?.tiotaggarlosning?.datum }})</span
      >
      <span class="font-bold"> och i tidigare anställning</span></template
    >
    <template
      v-slot:value
      v-else-if="
        anstalldStore.itp2.data?.tiotaggarlosning?.status ===
        TiotaggarlosningStatus.EndastAktiv
      "
    >
      <span class="font-bold"> Ja</span>
      <span class="date"
        >({{ anstalldStore.itp2.data?.tiotaggarlosning?.datum }})</span
      ></template
    >
    <template
      v-slot:value
      v-else-if="
        anstalldStore.itp2.data?.tiotaggarlosning?.status ===
        TiotaggarlosningStatus.EndastInaktiv
      "
    >
      <span class="font-bold">I tidigare anställning</span></template
    >
  </section-row>
</template>

<script lang="ts" setup>
import { SectionRow } from "@/components/sections";
import { TiotaggarlosningStatus } from "@/composables/KundserviceAppApiClient";

import { useAnstalldStore } from "../store/anstalldStore";

const anstalldStore = useAnstalldStore();
</script>

<style scoped>
.date {
  color: var(--neutral-700);
}
</style>
